import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type React from 'react';

const GlobalCopilotFloatieButton = async () => {
  const { GlobalCopilotFloatieButton } = await import(
    /* webpackChunkName: "4-feat-global-copilot-floatie-button" */ './GatedGlobalCopilotFloatieButton'
  );

  return { default: GlobalCopilotFloatieButton };
};

export const LoadableGlobalCopilotFloatieButton: React.ComponentType<Record<string, never>> = lazyLoadOnRender({
  loader: GlobalCopilotFloatieButton,
});
